// Display helpers. Dates arrive as ISO strings ("2026-03-14") and are treated as plain calendar dates.

export function money(v: number | null | undefined): string {
  const n = Number(v || 0);
  return (
    (n < 0 ? "-£" : "£") +
    Math.abs(n).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  );
}

/** 3 -> "3", 2.5 -> "2.5", 1.25 -> "1.25" */
export function num(v: number | null | undefined): string {
  const n = Number(v || 0);
  return Number.isInteger(n) ? String(n) : String(Math.round(n * 100) / 100);
}

function parts(iso: string): Date {
  const [y, m, d] = iso.slice(0, 10).split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d));
}

const WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MON = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "Sat 14 Mar" */
export function dshort(iso: string): string {
  const d = parts(iso);
  return `${WD[d.getUTCDay()]} ${d.getUTCDate()} ${MON[d.getUTCMonth()]}`;
}

/** A short span for narrow screens: "3–4 Jan", "26 Jan – 24 Feb", or "11 Sep" for one day. */
export function dspan(first: string, last: string): string {
  const [a, b] = [parts(first), parts(last)];
  const day = (d: Date) => `${d.getUTCDate()} ${MON[d.getUTCMonth()]}`;
  if (first === last) return day(a);
  if (a.getUTCMonth() === b.getUTCMonth() && a.getUTCFullYear() === b.getUTCFullYear())
    return `${a.getUTCDate()}–${day(b)}`;
  return `${day(a)} – ${day(b)}`;
}

/** "Sat 14 Mar 2026" */
export const dlong = (iso: string) => `${dshort(iso)} ${iso.slice(0, 4)}`;

export function todayISO(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function addDays(iso: string, n: number): string {
  const d = parts(iso);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

/** Parse a number input; blank or junk -> fallback. */
export function toNum(v: string | number | null | undefined, fallback = 0): number {
  if (v === null || v === undefined || v === "") return fallback;
  const n = typeof v === "number" ? v : parseFloat(v);
  return Number.isFinite(n) ? n : fallback;
}

/** 525 -> "8h 45m"; 60 -> "1h 00m" */
export function hm(minutes: number | null | undefined): string {
  const m = Math.max(0, Math.round(Number(minutes || 0)));
  return `${Math.floor(m / 60)}h ${String(m % 60).padStart(2, "0")}m`;
}

/** "2026-10-15T08:30:00" -> "08:30" (the server sends UK local time) */
export const timeOf = (local: string) => local.slice(11, 16);
